import { TextareaAutosize, Typography } from '@material-ui/core';
import React, { FC } from 'react';

interface Props {
  remarksDetails: string;
  onChange: (val: string) => void;
  style?: {};
}

export const RemarksDetails: FC<Props> = ({
  remarksDetails,
  onChange,
  style = {}
}) => {
  return (
    <div style={style}>
      <Typography style={{ fontWeight: 'bold' }}>Remarks</Typography>

      <TextareaAutosize
        value={remarksDetails}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Add Remarks"
        style={{
          fontFamily: 'roboto',
          fontSize: '.9em',
          width: '100%',
          height: '5em',
          border: '1px solid #ccc',
          borderRadius: 4,
          padding: '10px 12px'
        }}
      />
    </div>
  );
};
